/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { ExperimentControl, ExperimentVariant, Experiment } from '@shared-ui/experiment-context';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { Lazy } from './lazy';

export interface LazyImageProps {
  experimentName?: string;
  altPlaceholderText?: string;
  className?: string;
  updateLoaded: any;
  isGallery: boolean;
  device: string;
  children?: React.ReactNode;
}
export const LazyImage: React.FC<LazyImageProps> = ({
  experimentName,
  children,
  className,
  altPlaceholderText,
  updateLoaded,
  isGallery,
  device,
}) => {
  let loadTop = 0;
  let loadBottom = 0;

  if (typeof document !== 'undefined') {
    if (document.body.offsetWidth > 1900) {
      loadTop = 850;
      loadBottom = 850;
    } else if (document.body.offsetWidth >= 922) {
      loadTop = 750;
      loadBottom = 750;
    } else if (document.body.offsetWidth >= 691) {
      loadTop = 300;
      loadBottom = 300;
    } else if (document.body.offsetWidth >= 667) {
      loadTop = 350;
      loadBottom = 350;
    } else if (document.body.offsetWidth >= 375) {
      loadTop = 225;
      loadBottom = 225;
    } else {
      loadTop = 75;
      loadBottom = 75;
    }
  }

  if (isGallery) {
    if (device === 'desktop') {
      loadTop = 0;
      loadBottom = 0;
    } else if (device === 'tablet') {
      loadTop = -100;
      loadBottom = -100;
    } else if (device === 'mobile') {
      loadTop = 100;
      loadBottom = 100;
    }
  }

  const lazyImage = (
    <Lazy className={className} loadOffset={{ top: loadTop, bottom: loadBottom }} updateLoaded={updateLoaded}>
      <Lazy.Placeholder>
        <UitkFigure>
          <UitkImage alt={altPlaceholderText} placeholderImage={true} />
        </UitkFigure>
      </Lazy.Placeholder>
      <Lazy.Loaded>{children}</Lazy.Loaded>
    </Lazy>
  );

  if (!experimentName) {
    return lazyImage;
  }

  return (
    // <Experiment name={experimentName}>
    //   <ExperimentControl>{children}</ExperimentControl>
    //   <ExperimentVariant bucket={1}>{lazyImage}</ExperimentVariant>
    // </Experiment>
    <>{children}</>
  );
};
